import type {AccountType} from "@hosttools/core/constant";
import {useMemo} from "react";

import {buildChannel} from "../../../models/channel";
import type {ChannelMapType, ICalChannelObject, OtherChannelObject} from "../../../models/channel";

function useChannel<T extends AccountType | "internal" | "direct">(channel: T): ChannelMapType[T];

function useChannel(
    channel: string,
    isChannelConnector?: boolean
): OtherChannelObject | ICalChannelObject;

function useChannel(
    channel: AccountType | "internal" | "direct" | (string & {}),
    isChannelConnector?: boolean
) {
    return useMemo(() => buildChannel(channel, isChannelConnector), [channel, isChannelConnector]);
}

export default useChannel;
